import { BASE_URL } from '../../../../../utils/config.base-url'

// export const PROJECT_PREFIX_URL = '/project'
// export const PROJECT_DETAIL_PREFIX_URL = '/project-detail'
export const PROJECT_DEPARTMENT_PREFIX_URL = '/project-department'
export const PROJECT_GENERAL_PREFIX_URL = '/project-general'
export const PROJECT_TEMPLATE_PREFIX_URL = '/project-template'
export const PROJECT_MY_TASKS_PREFIX_URL = '/my-tasks'
export const URL_ENDPOINT_PROJECT = `${BASE_URL}/project`
